import { useState } from 'react';

// graphql
import { useCashierProfileQuery } from '@/generated/graphql';

// material ui
import { Box, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

// components
import { CashTransfers } from './components/cash-transfers/cash-transfers';
import { CashWithdrawals } from './components/cash-withdrawals/cash-withdrawals';
import { CashBalanceCard } from './components/cash-balance-card';

// helpers
import { formatNumber } from '@/shared/constants';

export const AdminCashTransactionPage = () => {
  const [tabValue, setTabValue] = useState('1');

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  const [cashBalance, setCashBalance] = useState('0');

  const cashierProfileQuery = useCashierProfileQuery({
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      setTimeout(() => {
        setCashBalance(formatNumber(data.cashierProfile?.cashBalance));
      }, 100);
    },
  });

  const refetch = () => {
    cashierProfileQuery.refetch();
  };

  return (
    <>
      <CashBalanceCard cashBalance={cashBalance} />
      <Box sx={{ width: '100%', typography: 'body1', ml: 1 }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="Transfers" value="1" />
              <Tab label="Withdrawals" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" style={{ padding: '0em' }}>
            <CashTransfers refetch={refetch} />
          </TabPanel>
          <TabPanel value="2" style={{ padding: '0em' }}>
            <CashWithdrawals refetch={refetch} />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};
